// extracted by mini-css-extract-plugin
module.exports = {"colors":"'~styles/colors.module.css'","NEUTRAL_GRAY_200":"#E2E8F0","menuListRoot":"styles_menuListRoot__bN2yZ","menuListContent":"styles_menuListContent__drBdg"};